import { createContext } from "react";

export interface WsState {
  webSocket: WebSocket | null;
  connectWebSocket(): void;
  disconnectWebSocket(): void;
}

export const webSocketInitialState: WsState = {
  webSocket: null,
  connectWebSocket: () => {},
  disconnectWebSocket: () => {},
};

export const WebSocketContext = createContext(webSocketInitialState);
